import React, { Component } from 'react'
import { connect } from 'react-redux'
import StyleSheet from 'styles'
import Dependent from 'containers/shared/Dependent'
import { UserActions, CountryActions, SnackbarActions } from 'actionsets'
import { Register } from 'components/account'
import CenteredContent from 'containers/CenteredContent'
import Typography from '@material-ui/core/Typography'
import {StyledForm, CountrySelect, Select, TextField} from 'components'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import Button from '@material-ui/core/Button'
import {FormContext} from 'components'
import Collapse from '@material-ui/core/Collapse'
import pluralize from 'pluralize'

export class Invite extends Component {

  constructor(props){
    super(props)
    this.state = {
      context: {
        account: {},
        accessLevel: 'member',
      },
      reject: false
    }
    UserActions.bindActions(this)
    CountryActions.bindActions(this, 'country')
    SnackbarActions.bindActions(this, 'snackbar')
    this.onSaveRoute = '/users'
  }

  dependsOn() {
    this.actions.country.index()
  }

  dependenciesMet() {
    return true
  }

  get errors() {
    return (this.props.errors.invite || {}).meta
  }

  get userParams() {
    const {account: {type, ...account}, ...user} = this.state.context
    if (type)
      user[`${pluralize.singular(type)}Attributes`] = account
    return user
  }

  handleSave = async() => {
    try {
      await this.actions.invite(this.userParams)
      this.actions.snackbar.show(`Invited: ${this.state.context.email}`)
      this.saveSuccess()
    }
    catch (e) {
      this.saveFailed()
    }
  }

  saveSuccess = () => {
    this.actions.snackbar.show(`Invited: ${this.state.context.email}`)
    this.props.history.push('/users/')
  }

  saveFailed = () => {
    this.actions.snackbar.error('Error inviting: User')
  }

  handleUserChange = context => this.setState({context})
  handleAccountChange = account => this.setState({context: {...this.state.context, account}})

  render = () =>
    <CenteredContent>
      <StyledForm style={{maxWidth: 556}}>
        <FormContext context={this.state.context} onChange={this.handleUserChange} errorContext={this.errors}>
          <Typography variant='h5'>New User</Typography>

          <div className={styles.section}>
            <TextField focusFirst label='Email' member='email' />
            <TextField label='Full name' member='name' />
            <CountrySelect member='countryId' label="Country" countries={this.props.countries} />
            <Select label='Type' member='accessLevel' options={accessLevelOptions}/>
          </div>

          <Collapse in={this.state.context.accessLevel !== 'admin'}>
            <div className={styles.section}>
              <Typography variant="h6">Account Type</Typography>
              <RadioGroup name='accountType1' member='account.type' required doesNotDisplayErrors>
                <FormControlLabel value="" label="None" control={<Radio/>}/>
                <FormControlLabel value="investorAccounts" label="Investor" control={<Radio/>}/>
                <FormControlLabel value="issuerAccounts" label="Issuer" control={<Radio/>}/>
              </RadioGroup>
            </div>

            <Collapse in={!!this.state.context.account.type}>
              <Register context={this.state.context.account} onChange={this.handleAccountChange} tncs={{}}/>
            </Collapse>
          </Collapse>

          <Button onClick={this.handleSave} variant='contained' color='primary'>Invite</Button>
        </FormContext>
      </StyledForm>
    </CenteredContent>
}

const accessLevelOptions = [{label: 'Member', value: 'member'}, {label: 'Admin', value: 'admin'}]

const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    flex: 1
  },
  section: {
    marginBottom: 50,
    position: 'relative'
  },
})
export default connect(({users, countries}) => ({...countries, ...users}))(Dependent({loader: true, wrapperClassName: styles.wrapper})(Invite))